module.exports = __webpack_public_path__ + "img/next.e3b0a3b8.svg";